import clsx from "clsx"
import { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import { HowItWorksText } from "../HowItWorksText"
import { HowItWorksTitle } from "../HowItWorksTitle"
import styles from "./HowItWorksSlide.module.scss"
import { IHowItWorksSlide } from "./types.ts"

const YOUTUBE_IDS: Record<string, string> = {
  uk: "IAce0jhkksA",
  ru: "IAce0jhkksA",
  en: "iMxMB0OYaAo"
}

export const HowItWorksIntroSlide: FC<IHowItWorksSlide> = () => {
  const { t, i18n } = useTranslation("howItWorks")
  const lang = i18n.language.split("-")[0]
  const videoId = YOUTUBE_IDS[lang] ?? YOUTUBE_IDS.en
  return (
    <div className={clsx(styles.HowItWorksSlide, styles.slide_intro)}>
      <HowItWorksTitle>{t("slides.intro.title")}</HowItWorksTitle>
      <HowItWorksText position="center">
        <Trans
          i18nKey="slides.intro.text1"
          ns="howItWorks"
          components={{ span: <span />, br: <br /> }}
        />
      </HowItWorksText>
      <HowItWorksText position="center">
        <Trans
          i18nKey="slides.intro.text2"
          ns="howItWorks"
          components={{ span: <span />, br: <br /> }}
        />
      </HowItWorksText>
      <iframe
        className={clsx(styles.HowItWorksSlide_video)}
        src={`https://www.youtube.com/embed/${videoId}`}
        title={t("slides.intro.title")}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  )
}
